
   $(document).on('click', '.next_tumb_click', function(){
  var selectThumb = $('.thumbnail[aria-current]').parent();
      var nextThumb = $(selectThumb).next().children('.thumbnail')
       $(nextThumb).trigger('click');
  });
$(document).on('click', '.prev_tumb_click', function(){
    var selectThumb = $('.thumbnail[aria-current]').parent();
        var nextThumb = $(selectThumb).prev().children('.thumbnail')
         $(nextThumb).trigger('click');
    });
$(document).ready(function(){
   if ($(".thumbnail[aria-current]").length === 0) {
        // Show alert message if element not found
        $('.prev_tumb_click, .next_tumb_click').remove();
    }
})